<template>
	<card class="ReCardTicketFaqEdit">
		<div class="bntGroup">
			<base-button @click="GoToEdit(false)" type="primary" class="no-border" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
		</div>
		<h4 >Редактирование данных</h4>
		
		<hr>
		
		<ReFormPrinter 
			:masFormConfig="masAllFormParams" 
			:objSaveApiMethod="currentApiFormMethod"		
			:SuccessGo="SuccessGo"/>
	</card>
</template>

<script>
	import ReFormPrinter from 'src/our_components/FormPrinter/ReFormPrinter.vue';

	export default {
		name: 'ReCardTicketFaqEdit',
		components: {
			ReFormPrinter,
		},
		props: {
			objFAQ: Object,
		},
		data () {
			return {
				ver: 1,
				currentApiFormMethod: this.currentApiFormMethodComp(),
				masAllFormParams: this.currentFormConfig(),
				strMethod: '',	
				masTopicTags: [],				
			}
		},
		watch:{
			
		},
		computed: {
			
		},
		methods: {
			currentApiFormMethodComp(){
				let faq_id = typeof this.$route.params.faq_id == 'undefined'?'-1':this.$route.params.faq_id;
				/*if(location.pathname.indexOf('/data/clients/add') != -1){
					return {apiMethod:'INS',apiParam:{obj:'client' ,flt:{id:'-1'},iData:[]}};
				} else {
					let client_id = typeof this.$route.params.client_id == 'undefined'?'':this.$route.params.client_id;
					//this.objClient.id
					return {apiMethod:'UPD',apiParam:{obj:'client' ,flt:{id:client_id},uData:[]}};
				}*/
				
				return {apiMethod:'INSUPD_TICKET_FAQ',apiParam:{obj:'TicketSystem' ,flt:{id:faq_id},iData:[]}};
			},
			currentFormConfig(){
				let faq_id = typeof this.$route.params.faq_id == 'undefined'?'-1':this.$route.params.faq_id;

				this.$GVO.ApiCall('GET_FORM_TICKET_FAQ',{obj:'TicketSystem',flt:{'id':faq_id,}})
				.then((objApi) => {
					// console.log(objApi);
					if(objApi.success){
						// console.log('TicketSystem.GET_FORM_TICKET_FAQ',this.$GVO.unlinkObject(objApi.config));
						this.masAllFormParams = objApi.config;
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
				return [];
				
			},
			
			SuccessGo(evt,dopParam){
				// console.error('SuccessGo',evt,dopParam,typeof dopParam.data.new_id);
				location.href = '/data/TicketSystem/faq';

				// if(location.pathname.indexOf('/data/clients/add') != -1){
				// 	console.log('SuccessGo',evt,dopParam,typeof dopParam.data.new_id);
				// 	if(typeof dopParam.data.new_id != 'undefined'){
				// 		console.log(dopParam.data.new_id);
				// 		location.href = '/data/clients/id/'+dopParam.data.new_id;
				// 	}else{
				// 		location.href = '/data/clients';
				// 	}
				// }else{
				// 	location.href = this.$GVO.str_replace('/edit','',evt);
				// 	console.log('SuccessGo',evt);
				// }
			},
			GoToEdit(bGoEdit=true){
			//this.bIsEdit = bGo;
				if(bGoEdit){
					this.$router.push({path: '/data/TicketSystem/faq/id/'+this.$route.params.lead_id+'/edit'});
					// this.$router.push({path: '/data/callcenter/id/'+this.$route.params.lead_id+'/edit?client_type='+this.masClient[0].client_type});
				}else{
					// console.log('this.$router.go(-2)');
					this.$router.go(-1);
					// if(this.bIsNew){ // Добавление лида
					// 	this.$router.push({path: '/data/callcenter'});
					// 	sessionStorage.removeItem("lead-search-objects");
					// }else{
					// 	console.log('this.$router.go(-2)');
					// 	this.$router.go(-2);
					// }
				}
			},
		},
		mounted() {

			// this.$GVO.LoadCatPromise('CAT_TICKET_TAGS')
			// 			.then((objApi) => {
			// 				if(objApi=== true){
			// 					// this.masTopicTags = []
			// 					for (let i = 0; i < this.$GVO.cats.CAT_TICKET_TAGS.length; i++) {
			// 						const element = this.$GVO.cats.CAT_TICKET_TAGS[i];
			// 						if(element.act==1) this.masTopicTags.push({'value':element.val,'label':element.val, 'id':element.id}); //вопрос val или id ?
			// 					}
			// 				}
			// 			})
			// 			.catch(errorObjApi => {console.log(errorObjApi); });
			
		},
	}
</script>
<style scoped>
	.ReCardTicketFaqEdit hr{
		color:#01B0E0; 
		background-color: #01B0E0; 
		height: 2px;
	}
	.ReCardTicketFaqEdit .bntGroup{
		position: absolute;
		z-index: 1;
		right: 15px;
		top: 5px;
	}

	.ReCardTicketFaqEdit >>> .ReCopyClipboard .btn.btn-icon:not(.btn-footer) .tim-icons{
		left: 45%;
		top: 47%;
	}
	

</style>
